export const createPriceFormatter = () => new Intl.NumberFormat(
    document.documentElement.dataset.locale || 'en-US',
    {
        style: 'currency',
        currency: document.documentElement.dataset.currency || 'USD'
    }
)
